interface IHeaderGroup {
  headers: unknown[];
}

export const getColSpan = (headerGroups: IHeaderGroup[]) =>
  headerGroups.reduce((cols, row) => Math.max(row.headers.length, cols), 0);
